import { NavLink as RouterNavLink, NavLinkProps } from "react-router-dom";
import { forwardRef } from "react";
import { cn } from "@/lib/utils";

interface NavLinkCompatProps extends Omit<NavLinkProps, "className"> {
  className?: string;
  activeClassName?: string;
  pendingClassName?: string;
  active?: boolean;
  onMouseEnter?: () => void;
  onFocus?: () => void;
}

const NavLink = forwardRef<HTMLAnchorElement, NavLinkCompatProps>(
  ({ className, activeClassName, pendingClassName, active, to, onMouseEnter, onFocus, ...props }, ref) => {
    return (
      <RouterNavLink
        ref={ref}
        to={to}
        className={({ isActive, isPending }) =>
          cn(className, (active ?? isActive) && activeClassName, isPending && pendingClassName)
        }
        onMouseEnter={onMouseEnter}
        onFocus={onFocus}
        {...props}
      />
    );
  },
);

NavLink.displayName = "NavLink";

export { NavLink };
